import Icons from "../../assets/icon";
import {
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import { PrefilledDropDown } from "../../components";
const LocationDetails = ({ control, watch, errors }) => {
  const selectedCountry = watch("countries");
  const selectedState = watch("state_id");
  const { data: dropdowns, isLoading, isError, error } = useDropdown();
  const {
    data: states,
    isLoading: isLoadingStates,
    isError: isErrorStates,
    error: errorStates,
  } = useStatesDropdowns(selectedCountry);
  const { data: cities, isLoading: citiesisLoading } =
    UsecitiesDropdowns(selectedState);

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading dropdowns: {error.message}
        </p>
      </div>
    );
  }
  if (isErrorStates) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading States: {errorStates.message}
        </p>
      </div>
    );
  }
  return (
    <div className={"flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto"}>
      <div className="flex items-center sm:gap-x-6 xs:flex-col">
        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
          <PrefilledDropDown
            options={dropdowns?.country || []}
            control={control}
            name="countries"
            label="Country"
            rightIcon={Icons.arrowIcon}
            isMandatory={true}
            valueoption="country_id"
            valueName="country"
            errors={errors}
            isLoading={isLoading}
          />
        </div>
        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
          <PrefilledDropDown
            control={control}
            errors={errors}
            rightIcon={Icons.arrowIcon}
            label={"Province / State"}
            options={states}
            valueName="state"
            isMandatory={true}
            valueoption="state_id"
            name={"state_id"}
            isLoading={isLoadingStates}
          />
        </div>
      </div>
      <div className="relative w-full">
        <PrefilledDropDown
          control={control}
          errors={errors}
          rightIcon={Icons.arrowIcon}
          label={"City"}
          options={cities}
          valueName="city"
          isMandatory={true}
          valueoption="city_id"
          name={"city_id"}
          isLoading={citiesisLoading}
        />
      </div>
    </div>
  );
};

export default LocationDetails;
